import '../../inc/block-patterns/header/headers.css';
import '../../inc/block-patterns/text/text.css';
import './filter.js';

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App';

// Initialize React app when the page loads
window.addEventListener('load', function() {
	console.log('TWN Form Script loaded');
	
	// Initialize React app if the target div exists
	const container = document.getElementById('twn-form-root');
	console.log('Found TWN container:', container);
	
	if (container) {
		console.log('Mounting React app to TWN container');
		const root = createRoot(container);
		root.render(
			<React.StrictMode>
				<App />
			</React.StrictMode>
		);
	} else {
		console.warn('TWN form container not found');
	}
});
